import React, { PropsWithChildren } from "react";
import { ContentWrapper } from "./Content.style";

const Content = ({ children }: PropsWithChildren) => (
  <ContentWrapper>{children}</ContentWrapper>
);

export default Content;
